<div class="page-wrapper">
  <div class="page-header">
    <h2>Security Settings</h2>
    <p class="subtitle">Manage two-factor authentication for your account.</p>
  </div>

  <div class="settings-card">
    <div class="card-row">
      <div class="card-info">
        <nb-icon icon="shield-outline" class="card-icon"></nb-icon>
        <div>
          <h4>Two-Factor Authentication (2FA)</h4>
          <p>Use Google Authenticator, Authy, or any TOTP-compatible app.</p>
        </div>
      </div>
      <span class="status-badge enabled" *ngIf="twoFactorEnabled">Enabled</span>
      <span class="status-badge disabled" *ngIf="!twoFactorEnabled">Disabled</span>
    </div>

    <!-- STATUS: DISABLED, no setup in progress -->
    <div *ngIf="!twoFactorEnabled && setupStep === 'idle'" class="action-area">
      <p class="hint">Your account is not protected by 2FA. Enable it to add an extra layer of security at login.</p>
      <button nbButton status="primary" (click)="startSetup()">Enable 2FA</button>
    </div>

    <!-- STATUS: ENABLED -->
    <div *ngIf="twoFactorEnabled && setupStep === 'idle'" class="action-area">
      <p class="hint">2FA is active on your account. You will be asked for a code each time you log in.</p>
      <button nbButton status="danger" outline (click)="openDisableModal()">Disable 2FA</button>
    </div>

    <!-- SETUP STEP 1: Show QR Code -->
    <div *ngIf="setupStep === 'scan'" class="setup-area">
      <h4>Step 1 — Scan this QR code</h4>
      <p>
        Open <strong>Google Authenticator</strong> (or Authy), tap <em>Add account</em>,
        then scan the code below:
      </p>
      <div class="qr-wrapper">
        <img [src]="qrCodeUrl" alt="2FA QR Code" width="200">
      </div>
      <details class="manual-entry">
        <summary>Can't scan? Enter the key manually</summary>
        <code class="secret-code">{{ manualSecret }}</code>
      </details>
      <div class="btn-row">
        <button nbButton status="primary" (click)="proceedToConfirm()">I've scanned it &rarr;</button>
        <button nbButton status="basic" outline (click)="cancelSetup()">Cancel</button>
      </div>
    </div>

    <!-- SETUP STEP 2: Confirm code -->
    <div *ngIf="setupStep === 'confirm'" class="setup-area">
      <h4>Step 2 — Confirm your authenticator app</h4>
      <p>Enter the 6-digit code currently shown in your authenticator app to verify the setup:</p>
      <input nbInput [(ngModel)]="verifyCode" (ngModelChange)="onVerifyInput()"
        type="text" inputmode="numeric" maxlength="6" placeholder="000000"
        class="totp-input">
      <p class="hint-small">Codes refresh every 30 seconds. If it doesn't work, wait for the next one.</p>
      <div class="btn-row" style="margin-top:1rem;">
        <button nbButton status="primary" [disabled]="verifyCode.length !== 6" (click)="confirmSetup()">
          Confirm &amp; Enable
        </button>
        <button nbButton status="basic" outline (click)="cancelSetup()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- DISABLE CONFIRMATION MODAL -->
<div class="modal-backdrop" *ngIf="showDisableModal" (click)="closeDisableModal()"></div>
<nb-card class="modal-card" *ngIf="showDisableModal">
  <nb-card-header>Disable Two-Factor Authentication</nb-card-header>
  <nb-card-body>
    <p style="color:#555; font-size:0.875rem; margin-bottom:1rem;">
      Enter your account password to confirm you want to disable 2FA.
    </p>
    <input nbInput fullWidth [(ngModel)]="disablePassword"
      type="password" placeholder="Enter your password">
  </nb-card-body>
  <nb-card-footer class="btn-row">
    <button nbButton status="danger" [disabled]="!disablePassword" (click)="confirmDisable()">
      Disable 2FA
    </button>
    <button nbButton status="basic" outline (click)="closeDisableModal()">Cancel</button>
  </nb-card-footer>
</nb-card>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
